import { createRecipe } from './runtime.js';

const gridLayoutConfig = {"name":"gridLayout","defaultVariants":{"gap":"8"},"variantMap":{"autoFit":["true"],"columns":["1","12","2","3","4","6"],"gap":["0","10","12","16","2","20","24","26","28","32","36","4","40","44","48","56","6","64","8","80","gutter"]}}

export const gridLayout = /* @__PURE__ */ createRecipe(gridLayoutConfig)